export class SiteBanner {
  constructor() { }
  id: number;
  severity: string;
  text: string;
  enabled: boolean;
  effectiveFrom: Date = new Date();
  effectiveTo: Date;
}